import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom"; // Keep useLocation here
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";


import NavbarComponent from "./Components/Navbar/NavbarComponent";

// Section pages
import MainHome from "./Components/Home/MainHome";
import Footer from "./Components/Footer/Footer";
import About from "./Components/About/MainAbout";
import MainService from "./Components/Services/MainService";
import RetentionCPE from "./Components/Services/AllServices/RetentionCPE";
import CustomerVerification from "./Components/Services/AllServices/CustomerVerification";
import FinancialServices from "./Components/Services/AllServices/FinancialServices";
import HrServices from "./Components/Services/AllServices/HRServices";
import WebDevelopment from "./Components/Services/AllServices/WebDevelopment";
import DigitalMarketing from "./Components/Services/AllServices/DigitalMarketing";
import AllServices from "./Components/Services/AllServices";
import Career from "./Components/Career/Career";
import Contact from "./Components/Contact/Contact";


// New Wrapper Component for AOS and Scroll
const AppContent = () => {
  const location = useLocation(); // Now useLocation is called within <Router> context

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
    // Refresh AOS to detect new elements on the new page
    // Using setTimeout here to ensure DOM is fully rendered before AOS refreshes
    // A small delay (e.g., 50ms) can often prevent elements from being missed
    setTimeout(() => {
      AOS.refreshHard(); // Use refreshHard for more thorough re-scan on route change
    }, 50);
  }, [location.pathname]); // Dependency array: runs when location.pathname changes

  return (
    // Apply overflowX: hidden to the outermost container to prevent horizontal scroll
    // This handles any potential overflow from AOS animations globally
    <div style={{ overflowX: 'hidden' }}>
      <NavbarComponent />

      <Routes>
        <Route path="/" element={<MainHome />} />
        <Route path="/about" element={<About/>} />
        <Route path="/services" element={<AllServices/>} />

        {/* All services routes */}
        <Route path="/retention-cpe" element={<RetentionCPE />} />
        <Route path="/customer-verification" element={<CustomerVerification/>} />
        <Route path="/financial-services" element={<FinancialServices/>} />
        <Route path="/hr-services" element={<HrServices/>} />
        <Route path="/web-development" element={<WebDevelopment/>} />
        <Route path="/digital-marketing" element={<DigitalMarketing/>} />

        <Route path="/career" element={<Career/>} />
        <Route path="/contact" element={<Contact/>} />
      </Routes>

      <Footer/>
    </div>
  );
};


function App() {
  // AOS.init should still be here, called once when the main App component mounts
  useEffect(() => {
    AOS.init({
      duration: 1000, // global duration
      once: true,    // whether animation should happen only once - while scrolling down
      // You can add other global settings here if needed
    });

    // Optional: Add a window load listener for the very first page load
    const handleLoad = () => {
      AOS.refreshHard(); // Use refreshHard to re-scan for all AOS elements after initial page load
    };
    window.addEventListener('load', handleLoad);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []); // Empty dependency array means this runs once on initial App mount


  return (
    <Router>
      {/* AppContent is now a child of Router, so useLocation() works */}
      <AppContent />
    </Router>
  );
}

export default App;